import React from "react";
import MyImage from "../images/myself.jpg";
import Ab1 from "../images/ab1.jpg";
import Ab2 from "../images/brazo2.png";

// import { FaLightbulb } from "react-icons/fa";
// import { PiSuitcaseSimpleBold } from "react-icons/pi";
// import { BiSupport } from "react-icons/bi";
import { FiDownloadCloud } from "react-icons/fi";
// import { VscProject } from "react-icons/vsc";
// import { FiCoffee } from "react-icons/fi";
// import { FiUsers } from "react-icons/fi";
// import { GiContract } from "react-icons/gi";
// import CountUp from "react-countup";
// import ScrollTrigger from "react-scroll-trigger";

const About = () => {
  // const [counterOn, setCounterOn] = useState(false);
  // const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="about" id="about">
        <h1 className="mainHeading">ABOUT ME</h1>
        <p className="mainPara">My Introduction</p>
        <div className="aboutContent">
          <div className="aboutRight">
            <img className="" src={MyImage} alt="" />
          </div>
          <div className="aboutLeft">
            {/* <div className="aboutTabs">
            
              <img className="aboutImg" src={Ab2} alt="" />
            </div> */}

            <p className="aboutPara animate__animated animate__fadeInUp">
             I’m an Automation and Control Systems engineer with a background in Computer Science. I enjoy building systems that connect machines, data, and software.

My work focuses on industrial automation using PLCs, HMI/SCADA systems, and data integration tools. I like creating complete solutions where machines are controlled, data is collected, and the system can be monitored in real time.

In my projects I work with technologies such as Allen-Bradley PLCs, Studio 5000, FactoryTalk, InduSoft, SQL databases, and Grafana dashboards.

I’m always learning and improving my skills, especially in automation, industrial data systems, and software development. My goal is to design efficient and reliable systems that solve real industrial problems
              
            </p>
            <a href="Resume.pdf" download="Resume.pdf">
              <button className="mainBtn aboutBtn animate__animated animate__fadeInUp">
                Get Resume
                <FiDownloadCloud className="btnIcon" />
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
